<li class="notifi-title js-alarm-replace">
	{{TR "Alarme"}}
</li>
{{#each alarmList}}
<li>
	<a href="#" class="js-alarm-menu-item js-alarm-replace">
		<i class="fa fa-exclamation-circle error" aria-hidden="true"></i> {{alarmName}}<br>{{name}}
		<small>{{triggeredAtStr}} - {{deviceName}}</small>
	</a>
</li>
{{/each}}
{{#if alarmShowMore}}
<li>
	<a href="#" class="js-alarm-menu-item js-alarm-replace">
		<i class="fa fa-exclamation-circle error" aria-hidden="true"></i> <small>+{{alarmShowMore}} {{TR "weitere"}}</small>
	</a>
</li>
{{/if}}
{{#if alarmList}}
{{else}}
<li>
	<a href="#" class="js-alarm-menu-item js-alarm-replace">
		<small>{{TR "Momentan sind keine neue Fehler gemeldet."}}</small>
	</a>
</li>
{{/if}}
